import { SavedFiltersStore } from '../components/table2/Filter3'
import { userStore } from '../stores/user_store'

export const savedFiltersStore = new SavedFiltersStore(userStore)

export function useSavedFiltersStore() {
    return savedFiltersStore
}
